import React from 'react';

const Dot: React.FC = () => (
  <div className="h-[0.1875rem] w-[0.1875rem] rounded-full bg-gray-medium" />
);

const ResizeHandle: React.FC = () => (
  <div className="pointer-events-none flex h-6 flex-col items-center justify-center gap-[0.1875rem] transition-transform group-hover:scale-150">
    <Dot />
    <Dot />
    <Dot />
  </div>
);

export default ResizeHandle;
